import { selectorFamily } from 'recoil';

import { IProduct } from 'Interfaces/Product';
import { productsState } from '../atoms';

export const nftProductState = selectorFamily<IProduct | null, number>({
	key: 'nftProductState',
	get:
		nftId =>
		({ get }) => {
			const products = get(productsState);

			return products.find(product => product.id === nftId) ?? null;
		}
});
